(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('DocumentoDBSearch', DocumentoDBSearch);

    DocumentoDBSearch.$inject = ['$resource'];

    function DocumentoDBSearch($resource) {
        var resourceUrl =  'api/_dbsearch/documentos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
